import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Tooltip/sgds-tooltip";
import { register } from "../../utils/ce-registry";

register("sgds-tooltip", Component);

export default createComponent({
  react: React,
  tagName: "sgds-tooltip",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
